export function getdata() {
	var obj = {
		headDataI: [{
				title: "扣除油品类别",
				prop: "tes1",
				width: "150px",
				custom: true,
			},
			{
				title: "上期库存数量",
				prop: "xfs_2_x_2",
				width: "150px",
				custom: true,
			},
			{
				title: "本期外购入库数量",
				prop: "xfs_2_x_3",
				width: "150px",
				custom: true,
			},
			{
				title: "委托加工收回连续生产数量",
				prop: "xfs_2_x_4",
				width: "150px",
				custom: true,
			},
			{
				title: "本期准予扣除数量",
				prop: "xfs_2_x_5",
				width: "150px",
				custom: true,
			},
			{
				title: "本期准予扣除税额",
				prop: "xfs_2_x_6",
				width: "150px",
				custom: true,
			},

			{
				title: "本期领用未用于连续生产不准予扣除数量",
				prop: "xfs_2_x_7",
				width: "150px",
				custom: true,
			}, {
				title: "期末库存数量",
				prop: "xfs_2_x_8",
				width: "150px",
				custom: true,
			}
		],

		tableDataI: [{},
			{
				tes1: "汽油",
				xfs_2_x_2: {
					cellCode: "xfs_2_1_2",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_3: {
					cellCode: "xfs_2_1_3",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_4: {
					cellCode: "xfs_2_1_4",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_5: {
					cellCode: "xfs_2_1_5",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_6: {
					cellCode: "xfs_2_1_6",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_7: {
					cellCode: "xfs_2_1_7",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_8: {
					cellCode: "xfs_2_1_8",
					cellType: "0",
					cellVal: "0.00"
				}
			}, {
				tes1: "柴油",
				xfs_2_x_2: {
					cellCode: "xfs_2_2_2",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_3: {
					cellCode: "xfs_2_2_3",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_4: {
					cellCode: "xfs_2_2_4",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_5: {
					cellCode: "xfs_2_2_5",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_6: {
					cellCode: "xfs_2_2_6",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_7: {
					cellCode: "xfs_2_2_7",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_8: {
					cellCode: "xfs_2_2_8",
					cellType: "0",
					cellVal: "0.00"
				}
			}, {
				tes1: "石脑油",
				xfs_2_x_2: {
					cellCode: "xfs_2_3_2",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_3: {
					cellCode: "xfs_2_3_3",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_4: {
					cellCode: "xfs_2_3_4",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_5: {
					cellCode: "xfs_2_3_5",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_6: {
					cellCode: "xfs_2_3_6",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_7: {
					cellCode: "xfs_2_3_7",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_8: {
					cellCode: "xfs_2_3_8",
					cellType: "0",
					cellVal: "0.00"
				}
			}, {
				tes1: "润滑油",
				xfs_2_x_2: {
					cellCode: "xfs_2_4_2",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_3: {
					cellCode: "xfs_2_4_3",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_4: {
					cellCode: "xfs_2_4_4",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_5: {
					cellCode: "xfs_2_4_5",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_6: {
					cellCode: "xfs_2_4_6",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_7: {
					cellCode: "xfs_2_4_7",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_8: {
					cellCode: "xfs_2_4_8",
					cellType: "0",
					cellVal: "0.00"
				}
			}, {
				tes1: "燃料油",
				xfs_2_x_2: {
					cellCode: "xfs_2_5_2",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_3: {
					cellCode: "xfs_2_5_3",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_4: {
					cellCode: "xfs_2_5_4",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_5: {
					cellCode: "xfs_2_5_5",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_6: {
					cellCode: "xfs_2_5_6",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_7: {
					cellCode: "xfs_2_5_7",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_8: {
					cellCode: "xfs_2_5_8",
					cellType: "0",
					cellVal: "0.00"
				}
			}, {
				xfs_2_x_2: {
					cellCode: "xfs_2_6_2",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_3: {
					cellCode: "xfs_2_6_3",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_4: {
					cellCode: "xfs_2_6_4",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_5: {
					cellCode: "xfs_2_6_5",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_6: {
					cellCode: "xfs_2_6_6",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_7: {
					cellCode: "xfs_2_6_7",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_8: {
					cellCode: "xfs_2_6_8",
					cellType: "0",
					cellVal: "0.00"
				}
			}
		],




		headDataII: [{
				title: "产品名称",
				prop: "tes1",
				width: "150px",
				custom: true,
			},
			{
				title: "上期库存数量",
				prop: "xfs_2_x_2",
				width: "150px",
				custom: true,
			},
			{
				title: "本期入库数量",
				prop: "xfs_2_x_3",
				width: "150px",
				custom: true,
			},
			{
				title: "本期生产领用数量",
				prop: "xfs_2_x_4",
				width: "150px",
				custom: true,
			},
			{
				title: "期末库存数量",
				prop: "xfs_2_x_5",
				width: "150px",
				custom: true,
			},
		],

		tableDataII: [{}, {
				tes1: "润滑油基础油（废矿物油）",
				xfs_2_x_2: {
					cellCode: "xfs_2_7_2",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_3: {
					cellCode: "xfs_2_7_3",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_4: {
					cellCode: "xfs_2_7_4",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_5: {
					cellCode: "xfs_2_7_5",
					cellType: "0",
					cellVal: "0.00"
				},
			}, {

				tes1: "变性燃料乙醇",
				xfs_2_x_2: {
					cellCode: "xfs_2_8_2",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_3: {
					cellCode: "xfs_2_8_3",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_4: {
					cellCode: "xfs_2_8_4",
					cellType: "0",
					cellVal: "0.00"
				},
				xfs_2_x_5: {
					cellCode: "xfs_2_8_5",
					cellType: "0",
					cellVal: "0.00"
				},
			},

		],
	}
	return obj
}